// extracted by mini-css-extract-plugin
module.exports = {"mask":"Fade_mask__pg_X8"};